(function () {
  const input = document.getElementById('DeckbuilderInput');
  const searchButton = document.getElementById('DeckbuilderSearchButton');
  const clearButton = document.getElementById('DeckbuilderClearButton');
  const statusEl = document.getElementById('DeckbuilderStatus');
  const resultsEl = document.getElementById('DeckbuilderResults');

  if (!input || !searchButton || !statusEl || !resultsEl) return;

  const config = window.TCG_DECKBUILDER_CONFIG || {};
  let lastFoundItems = [];

  function setStatus(message) {
    statusEl.textContent = message || '';
  }

  function normalizeCardName(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/[’‘]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function moneyFromNumber(value) {
    return `$${Number(value || 0).toFixed(2)}`;
  }

  function money(price) {
    if (!price) return '$0.00';
    return `$${Number(price.amount).toFixed(2)}`;
  }

  function getPriceNumber(option) {
    return Number(option.variant.price && option.variant.price.amount ? option.variant.price.amount : 0);
  }

  function getNumericVariantId(gid) {
    return String(gid || '').split('/').pop();
  }

  function cleanDeckLine(line) {
    let text = String(line || '').trim();

    if (!text) return null;

    if (/^(commander|sideboard|maybeboard|mainboard|deck|creatures|instants|sorceries|artifacts|enchantments|lands)$/i.test(text)) {
      return null;
    }

    text = text.replace(/^SB:\s*/i, '');

    const qtyMatch = text.match(/^(\d+)\s*x?\s+(.+)$/i);
    let quantity = 1;

    if (qtyMatch) {
      quantity = parseInt(qtyMatch[1], 10);
      text = qtyMatch[2];
    }

    text = text.replace(/\s+\([A-Z0-9]{2,6}\)\s+\d+[a-z]?$/i, '');
    text = text.replace(/\s+\*F\*$/i, '');
    text = text.replace(/\s+\/\/.*$/, '');
    text = text.trim();

    if (!text) return null;

    return {
      quantity,
      name: text,
      normalized: normalizeCardName(text)
    };
  }

  function parseDecklist(rawText) {
    const map = new Map();

    rawText.split(/\r?\n/).forEach((line) => {
      const parsed = cleanDeckLine(line);
      if (!parsed) return;

      if (!map.has(parsed.normalized)) {
        map.set(parsed.normalized, {
          name: parsed.name,
          quantity: 0,
          normalized: parsed.normalized
        });
      }

      map.get(parsed.normalized).quantity += parsed.quantity;
    });

    return Array.from(map.values());
  }

  async function storefrontRequest(query, variables) {
    if (!config.shopDomain || !config.storefrontToken) {
      throw new Error('Missing Storefront API setup. Add your Storefront API token in the deckbuilder section settings.');
    }

    const response = await fetch(`https://${config.shopDomain}/api/2026-01/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.storefrontToken
      },
      body: JSON.stringify({ query, variables })
    });

    const json = await response.json();

    if (json.errors) {
      console.error(json.errors);
      throw new Error('Shopify returned an API error.');
    }

    return json.data;
  }

  function titleLooksLikeCard(productTitleRaw, card) {
    const productTitle = normalizeCardName(productTitleRaw);
    const cardName = card.normalized;

    return (
      productTitle === cardName ||
      productTitle.startsWith(cardName + ' (') ||
      productTitle.startsWith(cardName + ' -') ||
      productTitle.startsWith(cardName + ' —') ||
      productTitle.startsWith(cardName + ' [')
    );
  }

  function escapeSearchText(text) {
    return String(text || '').replace(/"/g, '\\"');
  }

  function buildSearchQueries(card) {
    const queries = [];

    queries.push(escapeSearchText(card.name));
    queries.push(`title:"${escapeSearchText(card.name)}"`);

    const words = card.name.split(/\s+/).filter(Boolean);

    const firstWord = words[0];
    if (firstWord && firstWord.length >= 3) {
      queries.push(escapeSearchText(firstWord));
    }

    const lastWord = words[words.length - 1];
    if (lastWord && lastWord.length >= 3 && lastWord.toLowerCase() !== String(firstWord || '').toLowerCase()) {
      queries.push(escapeSearchText(lastWord));
    }

    return Array.from(new Set(queries));
  }

  function detectCondition(text) {
    const t = normalizeCardName(text);

    if (/\b(near mint|nm)\b/.test(t)) return 'nm';
    if (/\b(light play|lightly played|lp)\b/.test(t)) return 'lp';
    if (/\b(medium play|moderately played|mp)\b/.test(t)) return 'mp';
    if (/\b(heavy play|heavily played|hp)\b/.test(t)) return 'hp';
    if (/\b(damaged|poor)\b/.test(t)) return 'dmg';

    return 'unknown';
  }

  function conditionRank(conditionKey) {
    switch (conditionKey) {
      case 'nm': return 0;
      case 'lp': return 1;
      case 'mp': return 2;
      case 'hp': return 3;
      case 'dmg': return 4;
      default: return 999;
    }
  }

  function getSelectedConditions() {
    const checked = Array.from(document.querySelectorAll('.tcg-deckbuilder__condition-filter input[type="checkbox"]:checked'));
    return new Set(checked.map((input) => input.value));
  }

  function getSortMode() {
    const select = document.getElementById('DeckbuilderSortMode');
    return select ? select.value : 'price';
  }

  function sortOptions(options, sortMode) {
    return options.sort((a, b) => {
      const priceA = getPriceNumber(a);
      const priceB = getPriceNumber(b);

      const conditionA = conditionRank(a.conditionKey);
      const conditionB = conditionRank(b.conditionKey);

      if (sortMode === 'condition') {
        if (conditionA !== conditionB) return conditionA - conditionB;
        if (priceA !== priceB) return priceA - priceB;
      } else {
        if (priceA !== priceB) return priceA - priceB;
        if (conditionA !== conditionB) return conditionA - conditionB;
      }

      return getOptionLabel(a).localeCompare(getOptionLabel(b));
    });
  }

  function allocateRows(options, requested) {
    const rows = [];
    let remaining = requested;

    options.forEach((option, index) => {
      if (remaining <= 0) return;

      const qty = Math.min(option.quantityAvailable, remaining);

      if (qty > 0) {
        rows.push({
          optionIndex: index,
          quantity: qty
        });

        remaining -= qty;
      }
    });

    if (!rows.length && options.length) {
      rows.push({
        optionIndex: 0,
        quantity: 0
      });
    }

    return rows;
  }

  function getOptionLabel(option) {
    const productTitle = option.product.title || '';
    const variantTitle = option.variant.title || '';

    if (!variantTitle || variantTitle.toLowerCase() === 'default title') {
      return `${productTitle} — ${money(option.variant.price)} — ${option.quantityAvailable} available`;
    }

    return `${productTitle} / ${variantTitle} — ${money(option.variant.price)} — ${option.quantityAvailable} available`;
  }

  async function searchProductByExactTitle(card) {
    const query = `
      query SearchProducts($query: String!, $cursor: String) {
        products(first: 100, after: $cursor, query: $query) {
          pageInfo {
            hasNextPage
            endCursor
          }
          nodes {
            title
            handle
            onlineStoreUrl
            productType
            featuredImage {
              url
              altText
            }
            variants(first: 20) {
              nodes {
                id
                title
                availableForSale
                quantityAvailable
                price {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    `;

    const searchQueries = buildSearchQueries(card);
    const allowedConditions = getSelectedConditions();
    const sortMode = getSortMode();
    const optionsByVariantId = new Map();

    for (const baseSearchText of searchQueries) {
      let searchText = baseSearchText;

      if (config.productTypeFilter) {
        searchText += ` product_type:"${config.productTypeFilter.replace(/"/g, '\\"')}"`;
      }

      let cursor = null;
      let pagesChecked = 0;

      do {
        const data = await storefrontRequest(query, {
          query: searchText,
          cursor
        });

        const products = data.products.nodes || [];

        products.forEach((product) => {
          if (!titleLooksLikeCard(product.title, card)) return;

          product.variants.nodes.forEach((variant) => {
            if (!variant.availableForSale) return;

            const qtyAvailable = typeof variant.quantityAvailable === 'number' ? variant.quantityAvailable : 0;
            if (qtyAvailable <= 0) return;

            const combinedText = `${product.title} ${variant.title}`;
            const conditionKey = detectCondition(combinedText);

            if (conditionKey !== 'unknown' && !allowedConditions.has(conditionKey)) {
              return;
            }

            const numericVariantId = getNumericVariantId(variant.id);

            if (!optionsByVariantId.has(numericVariantId)) {
              optionsByVariantId.set(numericVariantId, {
                numericVariantId,
                product,
                variant,
                conditionKey,
                quantityAvailable: qtyAvailable,
                imageUrl: product.featuredImage && product.featuredImage.url ? product.featuredImage.url : '',
                imageAlt: product.featuredImage && product.featuredImage.altText ? product.featuredImage.altText : product.title
              });
            }
          });
        });

        cursor = data.products.pageInfo.endCursor;
        pagesChecked += 1;

        if (!data.products.pageInfo.hasNextPage) {
          break;
        }
      } while (pagesChecked < 5);
    }

    let options = Array.from(optionsByVariantId.values());

    if (!options.length) {
      return null;
    }

    options = sortOptions(options, sortMode);

    return {
      requested: card.quantity,
      name: card.name,
      options,
      rows: allocateRows(options, card.quantity)
    };
  }

  function ensurePreferenceControls() {
    const box = document.querySelector('.tcg-deckbuilder__box');
    if (!box) return;

    if (document.querySelector('.tcg-deckbuilder__filters')) return;

    const controls = box.querySelector('.tcg-deckbuilder__controls');
    const filters = document.createElement('div');
    filters.className = 'tcg-deckbuilder__filters';

    filters.innerHTML = `
      <div class="tcg-deckbuilder__filter-grid">
        <div class="tcg-deckbuilder__filter-block">
          <label class="tcg-deckbuilder__filter-label" for="DeckbuilderSortMode">Sort listings by</label>
          <select id="DeckbuilderSortMode" class="tcg-deckbuilder__sort-select">
            <option value="price">Cheapest first</option>
            <option value="condition">Best condition first</option>
          </select>
        </div>

        <div class="tcg-deckbuilder__filter-block">
          <div class="tcg-deckbuilder__filter-label">Acceptable conditions</div>
          <div class="tcg-deckbuilder__condition-filter">
            <label><input type="checkbox" value="nm" checked> Near Mint</label>
            <label><input type="checkbox" value="lp" checked> Light Play</label>
            <label><input type="checkbox" value="mp" checked> Medium Play</label>
            <label><input type="checkbox" value="hp" checked> Heavy Play</label>
            <label><input type="checkbox" value="dmg" checked> Damaged / Poor</label>
          </div>
        </div>
      </div>
    `;

    box.insertBefore(filters, controls);
  }

  function ensureLightbox() {
    if (document.getElementById('DeckbuilderLightbox')) return;

    const lightbox = document.createElement('div');
    lightbox.id = 'DeckbuilderLightbox';
    lightbox.className = 'tcg-deckbuilder__lightbox hidden';
    lightbox.innerHTML = `
      <div class="tcg-deckbuilder__lightbox-backdrop" data-lightbox-close="true"></div>
      <div class="tcg-deckbuilder__lightbox-content">
        <button type="button" class="tcg-deckbuilder__lightbox-close" data-lightbox-close="true" aria-label="Close image">×</button>
        <img id="DeckbuilderLightboxImage" src="" alt="" data-lightbox-close="true">
        <div class="tcg-deckbuilder__lightbox-hint">Tap image to close</div>
      </div>
    `;

    document.body.appendChild(lightbox);

    lightbox.addEventListener('click', function (event) {
      if (event.target.getAttribute('data-lightbox-close') === 'true') {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeLightbox();
      }
    });
  }

  function openLightbox(imageUrl, imageAlt) {
    ensureLightbox();

    const lightbox = document.getElementById('DeckbuilderLightbox');
    const image = document.getElementById('DeckbuilderLightboxImage');

    if (!lightbox || !image || !imageUrl) return;

    image.src = imageUrl;
    image.alt = imageAlt || '';

    lightbox.classList.remove('hidden');
    document.body.classList.add('tcg-deckbuilder__lightbox-open');
  }

  function closeLightbox() {
    const lightbox = document.getElementById('DeckbuilderLightbox');
    const image = document.getElementById('DeckbuilderLightboxImage');

    if (lightbox) {
      lightbox.classList.add('hidden');
    }

    if (image) {
      image.src = '';
      image.alt = '';
    }

    document.body.classList.remove('tcg-deckbuilder__lightbox-open');
  }

  function getCardGroupElement(cardIndex) {
    return document.querySelector(`.tcg-deckbuilder__card-group[data-card-index="${cardIndex}"]`);
  }

  function getSelectedOptionForRow(row) {
    const cardIndex = Number(row.getAttribute('data-card-index'));
    const select = row.querySelector('.tcg-deckbuilder__listing-select');
    const item = lastFoundItems[cardIndex];

    if (!item || !select) return null;

    const optionIndex = Number(select.value);
    return item.options[optionIndex] || null;
  }

  function renderListingSelectOptions(item, selectedOptionIndex) {
    return item.options.map((option, optionIndex) => {
      return `
        <option value="${optionIndex}" ${optionIndex === selectedOptionIndex ? 'selected' : ''}>
          ${escapeHtml(getOptionLabel(option))}
        </option>
      `;
    }).join('');
  }

  function renderRow(item, cardIndex, rowIndex, optionIndex, quantity, canRemove) {
    const option = item.options[optionIndex] || item.options[0];
    const productUrl = option.product.onlineStoreUrl || `/products/${option.product.handle}`;

    const imageHtml = option.imageUrl
      ? `
        <button
          type="button"
          class="tcg-deckbuilder__thumb-btn"
          data-image-url="${escapeHtml(option.imageUrl)}"
          data-image-alt="${escapeHtml(option.imageAlt || item.name)}"
          title="Click to enlarge"
        >
          <img src="${escapeHtml(option.imageUrl)}" alt="${escapeHtml(option.imageAlt || item.name)}">
        </button>
      `
      : `<div class="tcg-deckbuilder__thumb-placeholder">No image</div>`;

    return `
      <div class="tcg-deckbuilder__compact-row" data-card-index="${cardIndex}" data-row-index="${rowIndex}">
        <div class="tcg-deckbuilder__compact-thumb">
          ${imageHtml}
        </div>

        <div class="tcg-deckbuilder__compact-select-wrap">
          <select class="tcg-deckbuilder__listing-select">
            ${renderListingSelectOptions(item, optionIndex)}
          </select>

          <div class="tcg-deckbuilder__selected-link-wrap">
            <a class="tcg-deckbuilder__product-link" href="${escapeHtml(productUrl)}">
              View selected listing
            </a>
          </div>
        </div>

        <div class="tcg-deckbuilder__compact-qty">
          <label>Qty</label>
          <input
            type="number"
            min="0"
            max="${option.quantityAvailable}"
            value="${quantity}"
            class="tcg-deckbuilder__qty-input"
          >
        </div>

        <div class="tcg-deckbuilder__compact-remove">
          ${canRemove ? `<button type="button" class="tcg-deckbuilder__remove-row">Remove</button>` : ''}
        </div>
      </div>
    `;
  }

  function renderSummaryBox() {
    return `
      <div class="tcg-deckbuilder__summary-box" id="DeckbuilderSummaryBox">
        <div>
          <div class="tcg-deckbuilder__summary-label">Selected subtotal</div>
          <div class="tcg-deckbuilder__summary-value" id="DeckbuilderSubtotal">$0.00</div>
        </div>
        <div>
          <div class="tcg-deckbuilder__summary-label">Selected cards</div>
          <div class="tcg-deckbuilder__summary-value" id="DeckbuilderSelectedCards">0</div>
        </div>
        <div>
          <div class="tcg-deckbuilder__summary-label">Decklist requested</div>
          <div class="tcg-deckbuilder__summary-value" id="DeckbuilderRequestedCards">0</div>
        </div>
      </div>
    `;
  }

  function renderResults(found, missing) {
    lastFoundItems = found;

    let html = '';

    if (found.length) {
      html += renderSummaryBox();
    }

    html += `<h2 class="tcg-deckbuilder__section-title">Available cards</h2>`;

    if (found.length) {
      html += `
        <div class="tcg-deckbuilder__bulk-actions">
          <button id="DeckbuilderAddAllButton" class="button tcg-deckbuilder__primary-action" type="button">
            Add selected cards to cart
          </button>
          <span class="tcg-deckbuilder__bulk-note">
            Pick versions, adjust quantities, then add everything at once.
          </span>
        </div>
      `;

      found.forEach((item, cardIndex) => {
        const rowsHtml = item.rows.map((row, rowIndex) => {
          return renderRow(item, cardIndex, rowIndex, row.optionIndex, row.quantity, item.rows.length > 1);
        }).join('');

        html += `
          <div class="tcg-deckbuilder__card-group" data-card-index="${cardIndex}">
            <div class="tcg-deckbuilder__card-group-header">
              <div class="tcg-deckbuilder__card-title-wrap">
                <h3 class="tcg-deckbuilder__card-title">${escapeHtml(item.name)}</h3>
                <div class="tcg-deckbuilder__card-needed">Decklist asks for ${item.requested}</div>
              </div>

              <div class="tcg-deckbuilder__card-actions">
                <div class="tcg-deckbuilder__selected-summary">Selected 0 / ${item.requested}</div>
                <button
                  type="button"
                  class="tcg-deckbuilder__add-card-btn"
                  data-card-index="${cardIndex}"
                >
                  Add this card
                </button>
              </div>
            </div>

            <div class="tcg-deckbuilder__compact-rows">
              ${rowsHtml}
            </div>

            <button type="button" class="tcg-deckbuilder__add-row" data-card-index="${cardIndex}">
              + Add another printing
            </button>
          </div>
        `;
      });
    } else {
      html += `<p>No exact in-stock matches found.</p>`;
    }

    html += `<h2 class="tcg-deckbuilder__section-title">Missing / not found</h2>`;

    if (missing.length) {
      html += `
        <table class="tcg-deckbuilder__table">
          <thead>
            <tr>
              <th>Requested</th>
              <th>Card</th>
            </tr>
          </thead>
          <tbody>
      `;

      missing.forEach((item) => {
        html += `
          <tr class="tcg-deckbuilder__missing">
            <td data-label="Requested">${item.quantity}</td>
            <td data-label="Card">${escapeHtml(item.name)}</td>
          </tr>
        `;
      });

      html += `
          </tbody>
        </table>
      `;
    } else {
      html += `<p>Everything had at least one in-stock match.</p>`;
    }

    resultsEl.innerHTML = html;

    attachAllHandlers();
    updateAllSummaries();
  }

  function attachAllHandlers() {
    const addAllButton = document.getElementById('DeckbuilderAddAllButton');
    if (addAllButton) {
      addAllButton.addEventListener('click', addAllSelectedToCart);
    }

    document.querySelectorAll('.tcg-deckbuilder__listing-select').forEach((select) => {
      select.addEventListener('change', function () {
        handleListingChange(select.closest('.tcg-deckbuilder__compact-row'));
      });
    });

    document.querySelectorAll('.tcg-deckbuilder__qty-input').forEach((input) => {
      input.addEventListener('input', function () {
        handleQuantityChange(input);
      });
    });

    document.querySelectorAll('.tcg-deckbuilder__thumb-btn').forEach((button) => {
      button.addEventListener('click', function () {
        const imageUrl = button.getAttribute('data-image-url');
        const imageAlt = button.getAttribute('data-image-alt');

        if (imageUrl) {
          openLightbox(imageUrl, imageAlt);
        }
      });
    });

    document.querySelectorAll('.tcg-deckbuilder__add-row').forEach((button) => {
      button.addEventListener('click', function () {
        const cardIndex = Number(button.getAttribute('data-card-index'));
        addPrintingRow(cardIndex);
      });
    });

    document.querySelectorAll('.tcg-deckbuilder__remove-row').forEach((button) => {
      button.addEventListener('click', function () {
        const group = button.closest('.tcg-deckbuilder__card-group');
        const row = button.closest('.tcg-deckbuilder__compact-row');

        if (row) row.remove();

        renumberRows(group);
        updateAllSummaries();
      });
    });

    document.querySelectorAll('.tcg-deckbuilder__add-card-btn').forEach((button) => {
      button.addEventListener('click', function () {
        const cardIndex = Number(button.getAttribute('data-card-index'));
        addSingleCardGroupToCart(cardIndex);
      });
    });
  }

  function handleListingChange(row) {
    if (!row) return;

    const option = getSelectedOptionForRow(row);
    if (!option) return;

    const thumbWrap = row.querySelector('.tcg-deckbuilder__compact-thumb');
    const qtyInput = row.querySelector('.tcg-deckbuilder__qty-input');
    const link = row.querySelector('.tcg-deckbuilder__product-link');

    if (thumbWrap) {
      if (option.imageUrl) {
        thumbWrap.innerHTML = `
          <button
            type="button"
            class="tcg-deckbuilder__thumb-btn"
            data-image-url="${escapeHtml(option.imageUrl)}"
            data-image-alt="${escapeHtml(option.imageAlt || option.product.title)}"
            title="Click to enlarge"
          >
            <img src="${escapeHtml(option.imageUrl)}" alt="${escapeHtml(option.imageAlt || option.product.title)}">
          </button>
        `;

        const button = thumbWrap.querySelector('.tcg-deckbuilder__thumb-btn');
        button.addEventListener('click', function () {
          openLightbox(option.imageUrl, option.imageAlt || option.product.title);
        });
      } else {
        thumbWrap.innerHTML = `<div class="tcg-deckbuilder__thumb-placeholder">No image</div>`;
      }
    }

    if (qtyInput) {
      qtyInput.setAttribute('max', option.quantityAvailable);

      let currentQty = Number(qtyInput.value || 0);
      if (currentQty > option.quantityAvailable) {
        currentQty = option.quantityAvailable;
      }
      qtyInput.value = currentQty;
    }

    if (link) {
      link.href = option.product.onlineStoreUrl || `/products/${option.product.handle}`;
    }

    updateAllSummaries();
  }

  function handleQuantityChange(input) {
    const max = Number(input.getAttribute('max') || 0);
    let value = Number(input.value || 0);

    if (isNaN(value) || value < 0) value = 0;
    if (value > max) value = max;

    input.value = value;

    updateAllSummaries();
  }

  function addPrintingRow(cardIndex) {
    const item = lastFoundItems[cardIndex];
    const group = getCardGroupElement(cardIndex);
    const rowsContainer = group ? group.querySelector('.tcg-deckbuilder__compact-rows') : null;

    if (!item || !group || !rowsContainer) return;

    const currentRows = Array.from(group.querySelectorAll('.tcg-deckbuilder__compact-row'));
    const rowIndex = currentRows.length;

    let defaultOptionIndex = 0;
    const usedOptionIndexes = currentRows.map((row) => {
      const select = row.querySelector('.tcg-deckbuilder__listing-select');
      return select ? Number(select.value) : 0;
    });

    const unusedIndex = item.options.findIndex((option, index) => !usedOptionIndexes.includes(index));
    if (unusedIndex >= 0) {
      defaultOptionIndex = unusedIndex;
    }

    const tempWrapper = document.createElement('div');
    tempWrapper.innerHTML = renderRow(item, cardIndex, rowIndex, defaultOptionIndex, 0, true);

    const newRow = tempWrapper.firstElementChild;
    rowsContainer.appendChild(newRow);

    refreshRemoveButtons(group);
    attachHandlersForRow(newRow);
    updateAllSummaries();
  }

  function attachHandlersForRow(row) {
    const select = row.querySelector('.tcg-deckbuilder__listing-select');
    const input = row.querySelector('.tcg-deckbuilder__qty-input');
    const thumb = row.querySelector('.tcg-deckbuilder__thumb-btn');
    const remove = row.querySelector('.tcg-deckbuilder__remove-row');

    if (select) {
      select.addEventListener('change', function () {
        handleListingChange(row);
      });
    }

    if (input) {
      input.addEventListener('input', function () {
        handleQuantityChange(input);
      });
    }

    if (thumb) {
      thumb.addEventListener('click', function () {
        const imageUrl = thumb.getAttribute('data-image-url');
        const imageAlt = thumb.getAttribute('data-image-alt');

        if (imageUrl) {
          openLightbox(imageUrl, imageAlt);
        }
      });
    }

    if (remove) {
      remove.addEventListener('click', function () {
        const group = row.closest('.tcg-deckbuilder__card-group');
        row.remove();

        renumberRows(group);
        updateAllSummaries();
      });
    }
  }

  function renumberRows(group) {
    if (!group) return;

    const cardIndex = Number(group.getAttribute('data-card-index'));

    group.querySelectorAll('.tcg-deckbuilder__compact-row').forEach((row, rowIndex) => {
      row.setAttribute('data-card-index', cardIndex);
      row.setAttribute('data-row-index', rowIndex);
    });

    refreshRemoveButtons(group);
  }

  function refreshRemoveButtons(group) {
    if (!group) return;

    const rows = Array.from(group.querySelectorAll('.tcg-deckbuilder__compact-row'));

    rows.forEach((row) => {
      const removeCell = row.querySelector('.tcg-deckbuilder__compact-remove');
      if (!removeCell) return;

      if (rows.length > 1) {
        if (!removeCell.querySelector('.tcg-deckbuilder__remove-row')) {
          removeCell.innerHTML = `<button type="button" class="tcg-deckbuilder__remove-row">Remove</button>`;
          const button = removeCell.querySelector('.tcg-deckbuilder__remove-row');
          button.addEventListener('click', function () {
            row.remove();
            renumberRows(group);
            updateAllSummaries();
          });
        }
      } else {
        removeCell.innerHTML = '';
      }
    });
  }

  function getSelectedLineItemsForCard(cardIndex) {
    const group = getCardGroupElement(cardIndex);
    const item = lastFoundItems[cardIndex];

    if (!group || !item) return [];

    const rows = Array.from(group.querySelectorAll('.tcg-deckbuilder__compact-row'));
    const lineItems = [];

    rows.forEach((row) => {
      const option = getSelectedOptionForRow(row);
      const qtyInput = row.querySelector('.tcg-deckbuilder__qty-input');
      const qty = Number(qtyInput && qtyInput.value ? qtyInput.value : 0);

      if (!option || qty <= 0) return;

      lineItems.push({
        id: option.numericVariantId,
        quantity: qty
      });
    });

    return lineItems;
  }

  function getSelectedSubtotalForCard(cardIndex) {
    const group = getCardGroupElement(cardIndex);
    if (!group) return 0;

    const rows = Array.from(group.querySelectorAll('.tcg-deckbuilder__compact-row'));
    let subtotal = 0;

    rows.forEach((row) => {
      const option = getSelectedOptionForRow(row);
      const qtyInput = row.querySelector('.tcg-deckbuilder__qty-input');
      const qty = Number(qtyInput && qtyInput.value ? qtyInput.value : 0);

      if (!option || qty <= 0) return;

      subtotal += getPriceNumber(option) * qty;
    });

    return subtotal;
  }

  function updateAllSummaries() {
    let totalSelected = 0;
    let totalRequested = 0;
    let subtotal = 0;

    lastFoundItems.forEach((item, cardIndex) => {
      totalRequested += item.requested;

      const group = getCardGroupElement(cardIndex);
      if (!group) return;

      const inputs = Array.from(group.querySelectorAll('.tcg-deckbuilder__qty-input'));
      const selected = inputs.reduce((sum, input) => sum + Number(input.value || 0), 0);

      totalSelected += selected;
      subtotal += getSelectedSubtotalForCard(cardIndex);

      const summary = group.querySelector('.tcg-deckbuilder__selected-summary');

      if (summary) {
        summary.textContent = `Selected ${selected} / ${item.requested}`;
        summary.classList.remove('is-complete', 'is-incomplete', 'is-over');

        if (selected === item.requested) {
          summary.classList.add('is-complete');
        } else if (selected > item.requested) {
          summary.classList.add('is-over');
        } else {
          summary.classList.add('is-incomplete');
        }
      }
    });

    const subtotalEl = document.getElementById('DeckbuilderSubtotal');
    const selectedEl = document.getElementById('DeckbuilderSelectedCards');
    const requestedEl = document.getElementById('DeckbuilderRequestedCards');

    if (subtotalEl) subtotalEl.textContent = moneyFromNumber(subtotal);
    if (selectedEl) selectedEl.textContent = String(totalSelected);
    if (requestedEl) requestedEl.textContent = String(totalRequested);
  }

  async function addItemsToCart(items, redirectToCart) {
    if (!items.length) {
      setStatus('No selected quantities to add.');
      return;
    }

    setStatus(`Adding ${items.length} line item(s) to cart...`);

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const data = await response.json();

      if (!response.ok) {
        console.error(data);
        throw new Error(data.description || data.message || 'Could not add cards to cart.');
      }

      setStatus('Added cards to cart.');

      if (redirectToCart) {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    } catch (error) {
      console.error(error);
      setStatus(error.message);
    }
  }

  async function addAllSelectedToCart() {
    const items = [];

    lastFoundItems.forEach((item, cardIndex) => {
      const groupItems = getSelectedLineItemsForCard(cardIndex);
      groupItems.forEach((lineItem) => items.push(lineItem));
    });

    await addItemsToCart(items, true);
  }

  async function addSingleCardGroupToCart(cardIndex) {
    const item = lastFoundItems[cardIndex];

    if (!item) {
      setStatus('Could not find that card.');
      return;
    }

    const items = getSelectedLineItemsForCard(cardIndex);

    if (!items.length) {
      setStatus(`Select at least one quantity for ${item.name}.`);
      return;
    }

    await addItemsToCart(items, false);
  }

  async function runSearch() {
    resultsEl.innerHTML = '';
    lastFoundItems = [];

    const allowedConditions = getSelectedConditions();

    if (!allowedConditions.size) {
      setStatus('Select at least one acceptable condition.');
      return;
    }

    const cards = parseDecklist(input.value);

    if (!cards.length) {
      setStatus('Paste a decklist first.');
      return;
    }

    setStatus(`Checking ${cards.length} unique card names...`);

    const found = [];
    const missing = [];

    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      setStatus(`Checking ${i + 1} of ${cards.length}: ${card.name}`);

      try {
        const match = await searchProductByExactTitle(card);

        if (match) {
          found.push(match);
        } else {
          missing.push(card);
        }
      } catch (error) {
        console.error(error);
        setStatus(error.message);
        return;
      }
    }

    setStatus(`Done. Found ${found.length}; missing ${missing.length}.`);
    renderResults(found, missing);
  }

  ensurePreferenceControls();
  ensureLightbox();

  searchButton.addEventListener('click', runSearch);

  clearButton.addEventListener('click', function () {
    input.value = '';
    resultsEl.innerHTML = '';
    lastFoundItems = [];
    setStatus('');
  });
})();